export default __webpack_public_path__ + "static/media/collectible-final-special.e31c58c3.jpg";